import { render } from "./index.vue?vue&type=template&id=18f4bbc3&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=18f4bbc3&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=18f4bbc3&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f4bbc3"]])

export default __exports__